// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"59426fb7","385":"02445215","573":"3c7893fd","613":"00b6b0a3","623":"44e202b7","637":"bfae8131","952":"fe25ff9f"}[chunkId] + ".chunk.js";
};